/**
 * DADD'E - single source of truth for the SALE display.
 * 44 products: 19 at 50%, 10 at 30%, 14 at 20%, 1 at 10%.
 * Keys are Shopify product handles.
 *
 * enabled: the on/off switch for the whole SALE presentation - banner, % tags
 * and (in preview mode only) the simulated prices.
 *
 * 2026-09-09 - SWITCHED OFF. The summer sale ended on 25.8 but this file was
 * left at enabled:true on the live theme, so the % tags kept rendering for a
 * fortnight afterwards. The damage was not only "a sale that looks like it is
 * still running": 39 of these 44 products had already had their prices
 * restored in Shopify, so the tag was advertising a discount that did not
 * exist. Amelie X, for one, showed a red "50% OFF" beside a full 1,800 NIS
 * price. That is worse than a stale sale - the customer reads the tag, adds
 * to cart, and finds no discount at checkout.
 *
 * The list below is kept on purpose. It is the record of what was in the last
 * sale, it costs nothing while the switch is off, and deleting it would only
 * mean rebuilding it by hand next time. Turn this back on ONLY together with
 * the matching price changes in Shopify, and turn it off the same day those
 * prices are reverted - the switch and the prices have to move as one. That
 * coupling is the whole lesson of this bug.
 */
window.DADDE_SALE = {
  enabled: false,
  discounts: {
    /* ---- 50% OFF ---- */
    'identity-jumpsuit_': 50,
    'lyon-jacket': 50,
    'lion-pants-espresso': 50,
    'lion-jacket-copy': 50,
    'street-crop-hoodie': 50,
    'street-pants-1': 50,
    'the-presence-suit': 50,
    'parisienne-set': 50,
    'muse-suit': 50,
    'amelie-x': 50,
    'amelie-deep-cut': 50,
    'cotton-breeze-dress-melange-gray': 50,
    'boho-net-crop-set-silver': 50,
    'boho-net-long-set-silver': 50,
    'linen-set-long': 50,
    'telma-poncho-cream-copy': 50,
    'icon-skirt-cream-stone': 50,
    'lakshmi-shorts-black-gray': 50,
    'isabella-skirt-navy-blue': 50,
    /* ---- 30% OFF ---- */
    'strapless-top': 30,
    'muse-crop-shirt': 30,
    'solene-bralette': 30,
    'dorian-shorts': 30,
    'the-dorian-pants': 30,
    'the-dorian-jacket': 30,
    'summer-fit-shirt': 30,
    'fitted-tee-gray': 30,
    'oversized-tee-light-gray': 30,
    'classic-t-shirt-black': 30,
    /* ---- 20% OFF ---- */
    'the-rugby-crop-top': 20,
    'tuscany-chiffon-silk-set': 20,
    'riviera-lace-dress': 20,
    'riviera-lace-crop-top': 20,
    'riviera-lace-skirt': 20,
    'stripe-muse-dress': 20,
    'tailored-pants': 20,
    'tailored-bermuda': 20,
    'tailored-vest': 20,
    'denim-01': 20,
    'denim-1': 20,
    'boho-net-crop-set-copy': 20,
    'the-denim-power-shorts': 20,
    'wild-t-shirt-1': 20,
    /* ---- 10% OFF ---- */
    'amalfi-crochet-pants': 10
  }
};
